<template>
  <div id="start-view" class="start view start-gradient" :class="{ splashing: splash }">
    <div class="heart-back">
      <h3>Välkommen till</h3>
      <div class="title-img"></div>
      <div class="hide-splash">
        <div class="desktop-heart hide-splash"></div>
        <p><b>Är du nyfiken på hur du är som partner?</b></p>
        <p>I detta test får du svara på frågor kring ditt beteende i din relation.</p>
        <p class="italic mobile">Vi sparar ingen information från din Facebook-profil eller dina svar på frågorna.</p>
        <router-link class="start-button" to="quiz">Starta mitt test</router-link>
        <p class="italic desktop">Vi sparar ingen information från din Facebook-profil eller dina svar på frågorna.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StartView',
  data () {
    return {
      splash: true,
      msg: 'Empty component'
    }
  },
  props: [],
  computed: {},
  methods: {},
  mounted () {
    window.setTimeout(() => {
      this.splash = false
    }, 2000)
  },
  components: {}
}
</script>

<style scoped>
.italic {
  font-style: italic;
}
.title-img {
  width: 80%;
  height: 7.5vh;
  background-image: url('../assets/img/title.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  margin: auto;
  padding-bottom: 20px;
}
h3 {
  display: none;
}
.start {
  color: #fff;
}
.splashing h3 {
  display: block;
}
.splashing .hide-splash {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
}
.hide-splash {
  max-height: 1000px;
  max-width: 560px;
  margin: auto;
  box-sizing: border-box;
  transition: all 0.5s ease-in;
  opacity: 1;
}
h3 {
  font-weight: normal;
  text-transform: uppercase;
  font-size: 1.04em;
  letter-spacing: 1px;
  margin: 0;
}
.heart-back {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  z-index: 1;
  width: 100%;
  height: 90vh;
  position: relative;
  top: -10px;
  background-image: url('/static/heart_loading_empty.svg');
  background-size: 50% auto;
  background-repeat: no-repeat;
  background-position: center 10vh;
  transition: all 0.4s ease-in;
}
.desktop-heart {
  display: none;
  position: absolute;
  vertical-align: middle;
  text-align: center;
  z-index: 1;
  width: 100%;
  height: 100%;
  position: relative;
  top: 0px;
  left: 0px;
  background-image: url('/static/heart_loading_empty.svg');
  background-size: 50% auto;
  background-repeat: no-repeat;
  background-position: center 11vh;
  transition: all 0.5s ease-in;
}
.splashing .heart-back {
  background-size: 76% auto;
  background-repeat: no-repeat;
  background-position: center center;
}
.view {
  height: 100%;
  display: table;
  vertical-align: top;
  width: 100%;
}
.start-button {
  color: #ff5a6d;
  background-color: #fff;
  padding: 2.5vh;
  width: 75%;
  max-width: 250px;
  font-size: 0.9rem;
  border-radius: 6vh;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 700;
  position: relative;
  z-index: 9;
  box-sizing: border-box;
  margin-top: 2vh;
  display: inline-block;
}
p {
  margin: 4vh 4vh;
  font-size: 1.2rem;
  line-height: 1.5rem;
}
p:first-child {
  margin-top: 7vh;
}
@media screen and (min-width: 480px) {
  .start {
  }
  .heart-back {
    background-image: none;
    top: 0;
  }
  .splashing .heart-back {
    background-image: url('/static/heart_loading_empty.svg');
    background-size: 28vh;
  }
  .hide-splash {
    position: relative;
    padding-top: 5vh;
  }
  .desktop-heart {
    display: block;
    position: absolute;
    margin: auto;
    width: 20vw;
    margin-top: -25vh;
    left: calc(50% - 10vw);
  }
  .start-button {
    padding: 2.0vh;
  }
  .start-button:hover {
    opacity: 0.9;
  }
  h3 {
    font-size: 1rem;
  }
  p {
    margin: 5vh;
  }
  p b {
    font-size: 1.2em;
  }
  p:first-child {
    margin-top: 9vh;
  }
  .title-img {
    width: 20%;
    min-width: 300px;
    height: 6vh;
  }
  .italic {
    font-size: 0.9rem;
    line-height: 1rem;
    max-width: 400px;
    margin: auto;
    margin-top: 3vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StartView.vue